export default __webpack_public_path__ + "static/media/photo--sm--huda-3.3b127d10.jpg";